/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });

  // Read More / Read Less toggle for collection descriptions
  function initReadMore() {
    document.querySelectorAll('element-text-rte.rte--collection-desc').forEach(function(el) {

      if (el.dataset.readMoreInit) return;
      el.dataset.readMoreInit = 'true';

      // Get first non-empty paragraph
      const firstP = el.querySelector('p');
      if (!firstP) return;

      // Strip HTML tags to get plain text for sentence splitting
      const plainText = firstP.innerText.trim();
      const sentences = plainText.match(/[^.!?]+[.!?]+/g) || [];

      // If only one sentence, nothing to hide
      if (sentences.length <= 1) return;

      // Keep first sentence, hide the rest in a span
      const firstSentence = sentences[0];
      const restOfText = sentences.slice(1).join(' ');

      firstP.innerHTML = firstSentence + '<span class="clamp-hidden"> ' + restOfText + '</span>';

      // Hide all sibling elements after the first two (h2 + first p)
      const children = Array.from(el.children);
      children.slice(2).forEach(function(child) {
        child.classList.add('clamp-hidden');
      });

      const btn = document.createElement('button');
      btn.classList.add('read-more-btn');
      btn.textContent = 'Read More';

      btn.addEventListener('click', function() {
        el.classList.toggle('expanded');
        const isExpanded = el.classList.contains('expanded');
        btn.textContent = isExpanded ? 'Read Less' : 'Read More';

        if (isExpanded) {
          el.after(btn);
        } else {
          firstP.after(btn);
        }
      });

      // Initially place button after first paragraph
      firstP.after(btn);
    });
  }

  // Try on DOM ready, page:loaded, and after a short delay as fallback
  DOMready(initReadMore);
  document.addEventListener('page:loaded', initReadMore);
  setTimeout(initReadMore, 1500);

})();
